import { render, staticRenderFns } from "./select-income.vue?vue&type=template&id=541f38db&"
import script from "./select-income.vue?vue&type=script&lang=js&"
export * from "./select-income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports